interface Rules {
    id: number,
    text: string,
}

const rules: Rules[] = [
    {
        id: 0,
        text: 'Абонемент є персональним (іменним) та не підлягає передачі третім особам. Придбаний абонемент поверненню не підлягає. Його можна тільки переоформити з доплатою на іншу людину. 1 міс. - 50 грн, від 3-х міс. - 100 грн. Абонемент дійсний тільки в тому залі, в якому його придбали. Послуга переоформлення на інший зал CrossGYM - 100 грн.'
    },
    {
        id: 1,
        text: 'Клієнт має право на заморозку будь-якого виду абонемента: 1 міс. - 1 раз до 7 днів; 3 міс. - 1 раз до 21 дня; 6 міс. - 1 раз до 30 днів; 1 рік - 2 рази до 30 днів. Про заморозку абонемента попереджати заздалегідь. Заднім числом абонемент не заморожується.'
    },
    {
        id: 2,
        text: 'Абонемент активується з дати першого тренування, а не з дня покупки.'
    },
    {
        id: 3,
        text: 'Абонемент дійсний протягом року з дня покупки (активувати його необхідно протягом 12-ти місяців, інакше абонемент анулюється).'
    },
    {
        id: 4,
        text: 'Абонемент на кількість занять дійсний протягом року з початку активації абонементу.'
    },
    {
        id: 5,
        text: 'Абонемент є перепусткою до Фітнес-клубу "CrossGYM", який Ви зобов\'язані пред\'явити адміністратору при вході або оплатити разове відвідування.'
    },
    {
        id: 6,
        text: 'Абонемент можна оплачувати частинами: 1 міс.(8/12 занять) - 50% одразу, 50% протягом 2х тижнів; 3/6/12 міс. - 50% одразу, 50% протягом місяця; У разі прострочення оплати абонемент анулюється без повернення коштів.'
    },
    {
        id: 7,
        text: 'Клієнт несе персональну відповідальність за своє здоров\'я і медичне забезпечення.'
    },
    {
        id: 8,
        text: 'Абонемент діє тільки в тому залі в якому ви його придбали!'
    },
    {
        id: 9,
        text: 'Діти до 14-ти років мають право займатись тільки з тренером або під наглядом батьків.'
    },
    {
        id: 10,
        text: 'Купуючи абонемент на будь-який термін або разове заняття, Ви погоджуєтесь з "Правилами відвідування фітнес-клубу CrossGYM".'
    },
    {
        id: 11,
        text: 'Дітям, які не мають діючого абонементу заборонено займатись на тренажерах та знаходитись в тренажерній зоні.'
    },
    {
        id: 12,
        text: 'При відвідуванні спортивного клубу клієнтів з дітьми, відповідальність за їх дії (дітей), а також за самих дітей - несе клієнт, у супроводі з яким дитина знаходиться.'
    },
]

export default rules;